module.exports = __webpack_public_path__ + "img/plus-square-fill.008e6f33.svg";